import React, { type HTMLAttributes } from 'react';
import { Container } from '@uncinc/uncinc-react-kitchen-sink';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import { WysiwygField, DynamicMediaItem, ButtonWrapper } from '../../../components';
import type { ParagraphPreviousYears as Type } from '../../../types/uncinc_profile/paragraphs';

import './style.scss';

interface ParagraphAVOPreviousYearsProps
  extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<Type>;
}

const ParagraphAVOPreviousYears: React.FC<ParagraphAVOPreviousYearsProps> = ({
  entity,
}) => {
  const paragraph = entity.toJS().field_item;

  return (
    <div className="Paragraph ParagraphAVOPreviousYear">
      <Container>
        <div className="row">
          <div className="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
            <div className="ParagraphAVOPreviousYear">
              <div className="ParagraphAVOPreviousYear__items">
                {paragraph.map(({ entity: item }) => {
                  const body = item.field_body?.[0]?.value;
                  const title = item.field_title?.[0]?.value;
                  const link = item.field_link?.[0];
                  const image = item.field_media_item?.[0];
                  const theme = item.field_name?.[0]?.value;
                  const uri = link?.alias ?? link?.uri;

                  return (
                    <div className="ParagraphAVOPreviousYearItem">
                      <div className="ParagraphAVOPreviousYearItem__content">
                        <h3 className="ParagraphAVOPreviousYearItem__title">
                          {title}
                        </h3>
                        {theme && (
                          <div className="ParagraphAVOPreviousYearItem__theme">
                            {theme}
                          </div>
                        )}
                        {image && (
                          <DynamicMediaItem
                            imageAspectRatio="16_9"
                            media={image}
                            className="ParagraphAVOPreviousYearItem__image mobile"
                          />
                        )}
                        {body && (
                          <WysiwygField
                            property="schema:text"
                            className="ParagraphAVOPreviousYearItem__body"
                            html={body}
                          />
                        )}
                        {link && (
                          <ButtonWrapper href={uri}>
                            {link.title}
                          </ButtonWrapper>
                        )}
                      </div>
                      {image && (
                        <DynamicMediaItem
                          imageAspectRatio="16_9"
                          media={image}
                          className="ParagraphAVOPreviousYearItem__image desktop"
                        />
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default ParagraphAVOPreviousYears;
